import * as React from 'react';

import Fieldset from '../../../components/forms/Fieldset';
import { Button } from '../../../components/buttons';
import { IconChevronRight } from '../../../components/icons';
import Utils from '../../../common/utils';

import ValidateReferralCode from '../../../quoting/ValidateReferralCode';

interface Props {
	customerPolicy?: CustomerPolicy;
	hidden: boolean;
	premiumChanged: boolean;
	history?: any;
	match?: any;
	isLoading: boolean;
}
class ReviewPage extends React.Component<Props> {
	componentWillMount() {
		history.pushState(null, '', location.href);
		window.onpopstate = function (e: any) {
			history.go(1);
		};
	}

	next = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/beneficiary`);
	}

	render() {
		return (
			<div className="content-set" hidden={this.props.hidden}>
				<Fieldset>
					<ul className="list-unstyled d-lg-flex">
						<li className="mb-3 mb-lg-0 mr-lg-5 strong text-secondary">
							<span>Coverage</span>
							<div className="xlarge">{Utils.formatCurrency(this.props.customerPolicy!.coverageAmount, 0)} CAD</div>
						</li>
						<li className="mb-3 mb-lg-0 mr-lg-5 strong text-secondary">
							<span>Term</span>
							<div className="xlarge">{this.props.customerPolicy!.term} years</div>
						</li>
						<li>
							<span>Monthly payment</span>
							<div className="xlarge">
								{this.props.isLoading ? '-' : Utils.formatCurrency(this.props.customerPolicy!.rate, 2)}/month
							</div>
							<em className="text-primary font-weight-bold">First two months free</em>
						</li>
					</ul>
					{this.props.premiumChanged &&
						<p className="small mb-0">
							<em>
								Your monthly premium has increased due to your answers to the questionnaire. Certain lifestyle
								activities carry greater risk of death, which results in a higher insurance premium.
							</em>
						</p>
					}
					<ul className="list-unstyled mt-0">
						<li>Payment due: {Utils.formatDateAsUTC(this.props.customerPolicy!.effectiveDate, 'Do')} of every month</li>
						<li>
							Term duration:&nbsp;
							{Utils.formatDateAsUTC(this.props.customerPolicy!.effectiveDate, 'MMMM D, YYYY')} -&nbsp;
							{Utils.formatDateAsUTC(this.props.customerPolicy!.endDate, 'MMMM D, YYYY')}
						</li>
					</ul>
					<ValidateReferralCode />
					<p>
						Here is a <a href="/Term Life Policy Sample.pdf" target="_blank">sample policy</a>.
						A policy with your specific details will be provided upon payment.
					</p>
					<p>
						<b>
							Still thinking about it? Lock in your rate now with our money-back guarantee:
							if you cancel your policy within 30 days for any reason, we'll refund your payment.
						</b>
					</p>

				</Fieldset>
				<div className="workflow-progress-actions">
					<Button
						onClick={this.next}
						className="btn-primary workflow-progress-action"
						disabled={this.props.isLoading}
					>
						<span className="align-middle mx-2">Protect my family!</span>
						<IconChevronRight />
					</Button>
				</div>
			</div>
		);
	}
}
export default ReviewPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/billing-review/ReviewPage.tsx